<template>
  <div v-if="ready && data">
    <b-row>
      <b-col>
        <b-card :no-body="true">
          <b-card-body class="p-0">
            <div class="text-primary" style="font-size: large" v-if="ready && data && !loading">
              {{ totalKg | localeNumber }}
              <span class="text-muted text-uppercase font-weight-bold font-xs">Total</span>
            </div>
            <b-spinner v-if="loading"></b-spinner>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col v-for="(item, index) in data" :key="index">
        <b-card :no-body="true" :key="index">
          <b-card-body class="p-0">
            <div class="text-primary" style="font-size: large" v-if="ready && data && !loading">
              {{ item.data | localeNumber }}
              <span class="text-muted text-uppercase font-weight-bold font-xs">{{ item.label }}</span>
            </div>
            <b-spinner v-if="loading"></b-spinner>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      data: null,
      ready: false,
      loading: true
    };
  },
  computed: {
    lgCol() {
      return Math.round(12 / this.data.length);
    },
    totalKg() {
      return this.data
        .reduce((total, item) => {
          return total + parseFloat(item.data);
        }, 0)
        .toFixed(2);
    }
  },
  filters: {
    localeNumber(value) {
      return new Intl.NumberFormat("es-CL").format(value) + " Kg";
    }
  },
  props: ["client_customer", "from_date", "to_date", "product", "product_type"],
  async mounted() {
    try {
      const response = await this.$axios({
        method: "GET",
        url: `production/dashboard/stock/stock_by_product_type?client_customer=${this.client_customer}&product=${this.product}&product_type=${this.product_type}`,
        headers: {
          "Content-Type": "application/json"
        }
      });
      this.loading = false;
      this.data = response.data.labels.map((item, index) => {
        return {
          label: item,
          data: response.data.dataset[index]
        };
      });
      this.$emit("chart-ready");
    } catch (error) {
      console.log(error);
      this.loading = false;
    }
    this.$nextTick(() => {
      this.ready = true;
    });
  }
};
</script>

<style scoped>
.card {
  border-radius: 10px;
  padding: 10px;
}
</style>
